import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CarritoProvider } from './context/CarritoContext';
import { useFondo } from './components/SelectorFondo';
import Tienda from './pages/Tienda';
import Admin from './pages/Admin';

function FondoGlobal() {
  useFondo(); // aplica el fondo guardado en localStorage al montar, en cualquier ruta
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <FondoGlobal />
      <AuthProvider>
        <Routes>
          <Route
            path="/"
            element={
              <CarritoProvider>
                <Tienda />
              </CarritoProvider>
            }
          />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
